"use client"

import { useNativeCurrency } from "@/app/blockchains/use-blockchain"
import { CurrencyPrice } from "@/app/currency/currency-price/currency-price"
import type { Blockchain } from "@anaconda/core/blockchain/types"
import { reatomComponent } from "@reatom/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"

interface Props {
  blockchain: Blockchain
}

export function BlockchainNativeCurrencyPrice({ blockchain }: Props) {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <CurrencyPriceContent blockchain={blockchain} />
      </Suspense>
    </ErrorBoundary>
  )
}

const CurrencyPriceContent = reatomComponent<Props>(({ blockchain }) => {
  const nativeCurrency = useNativeCurrency(blockchain)

  return <CurrencyPrice currency={nativeCurrency} />
}, "CurrencyPriceContent")
